import { useState } from "react";
import { useTranslation } from "react-i18next";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { LinkButton, type LinkButtonProps } from "~/common/components/Link";
import { requestConfirmation } from "~/AddToCart/ModalSevice";
import ConfirmationModal from "~/common/components/ConfirmationModal";
import { CircularProgress, Typography } from "@mui/material";
import { addToComparison } from "~/ProductComparison/redux/actions";
import { sendData as clearComparisonListApi } from "~/ProductComparison/api/RemoveAllFromComparison";
import { useDispatch } from "react-redux";

type Props = LinkButtonProps & {
  products: string[];
};

export const MMDCompareProductsButton = (props: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    const hasCompareProducts = window.SCHA.productComparisonList.currentSize > 0;
    if (hasCompareProducts) {
      const confirmed = await requestConfirmation(({ onConfirm, onCancel }) => {
        return (
          <ConfirmationModal
            okLabel={t("feature.mmd.assistant.compareProducts.modal.yes")}
            cancelLabel={t("cancel")}
            onOk={onConfirm}
            onCancel={onCancel}
          >
            <Typography variant="bodyLarge">{t("feature.mmd.assistant.compareProducts.modal.confirm")}</Typography>
          </ConfirmationModal>
        );
      });
      if (!confirmed) {
        return;
      }
    }
    setLoading(true);
    if (hasCompareProducts) {
      await clearComparisonListApi();
    }
    for (const product of props.products) {
      await dispatch(addToComparison(product));
    }
    setLoading(false);
  };

  return (
    <LinkButton
      {...props}
      iconBefore={loading ? <CircularProgress size={24} /> : <OpenInNewIcon />}
      disabled={loading}
      onClick={handleClick}
      data-test-id="mmd-compare-products-button"
    >
      {t("feature.mmd.assistant.compareProducts.button")}
    </LinkButton>
  );
};
